import api from '@/api';

import { ListResult } from '@/core/request/ListResult';

import {
  PartVehicleApplication,
  CreatePartVehicleApplicationRequest,
  PartVehicleApplicationFree,
  CreatePartVehicleApplicationFreeRequest,
} from './PartVehicleApplications.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/parts/applications`;

export async function listPartVehicleApplicationsFree(
  partId?: number,
): Promise<ListResult<PartVehicleApplicationFree>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/part/${partId}`,
    null,
  )) as unknown;

  return result as ListResult<PartVehicleApplicationFree>;
}

export async function createPartVehicleApplicationFree(
  obj: CreatePartVehicleApplicationFreeRequest,
): Promise<PartVehicleApplicationFree> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as PartVehicleApplicationFree;
}

export async function deletePartVehicleApplicationFree(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function listPartVehicleApplications(
  partId?: number,
): Promise<ListResult<PartVehicleApplication>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/vehicles/part/${partId}`,
    null,
  )) as unknown;

  return result as ListResult<PartVehicleApplication>;
}

export async function createPartVehicleApplication(
  obj: CreatePartVehicleApplicationRequest,
): Promise<PartVehicleApplication> {
  const result = (await api.post(
    `${CONTROLLER_URL}/vehicles`,
    obj,
    null,
  )) as unknown;

  return result as PartVehicleApplication;
}

export async function deletePartVehicleApplication(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/vehicles/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
